import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    sin: '100h/año planificando desde cero',
    con: '10 min/semana. El resto es entrenar.'
  }, {
    sin: 'Ejercicios improvisados',
    con: '101 drills listos organizados por nivel'
  }, {
    sin: '60% de abandono antes del año',
    con: 'Sistema de retención más del 80%'
  }, {
    sin: 'Sin progresión clara',
    con: '6 tomos con categorías y sesiones completas'
  }, {
    sin: 'Sin evaluación formal',
    con: 'Fichas mensuales donde todos ven el progreso'
  }, {
    sin: 'Niveles mezclados igual caos',
    con: 'Variantes listas para todos los niveles'
  }, {
    sin: 'Sin identidad profesional',
    con: 'Sistema de gestión que justifica cobrar más'
  }, {
    sin: 'Conflictos con padres',
    con: 'Reglamento interno listo para firmar'
  }];
  return <section className="py-20 px-4 bg-dark-DEFAULT border-t border-dark-border" data-id="element-36">
      <div className="max-w-4xl mx-auto" data-id="element-37">
        <h2 className="text-4xl md:text-5xl font-bebas text-center mb-12" data-id="element-38">
          <span className="text-white" data-id="element-39">¿Cuánto cuesta </span>
          <span className="text-brand-DEFAULT" data-id="element-40">NO tenerlo?</span>
        </h2>

        <div className="bg-dark-card border border-dark-border rounded-xl overflow-hidden" data-id="element-41">
          <div className="grid grid-cols-2 bg-dark-DEFAULT border-b border-dark-border" data-id="element-42">
            <div className="p-4 md:p-6 text-center font-bebas text-xl text-text-secondary" data-id="element-43">
              Sin EDULABS
            </div>
            <div className="p-4 md:p-6 text-center font-bebas text-xl text-brand-DEFAULT border-l border-dark-border bg-dark-border" data-id="element-44">
              Con EDULABS
            </div>
          </div>

          <div className="divide-y divide-dark-border" data-id="element-45">
            {rows.map((row, index) => <div key={index} className="grid grid-cols-2" data-id="element-46">
                <div className="p-4 md:p-6 flex items-start space-x-3 bg-dark-card" data-id="element-47">
                  <XIcon size={20} className="text-text-secondary flex-shrink-0 mt-0.5" data-id="element-48" />
                  <span className="text-text-secondary text-sm md:text-base" data-id="element-49">
                    {row.sin}
                  </span>
                </div>
                <div className="p-4 md:p-6 flex items-start space-x-3 border-l border-dark-border bg-dark-border" data-id="element-50">
                  <CheckIcon size={20} className="text-brand-DEFAULT flex-shrink-0 mt-0.5" data-id="element-51" />
                  <span className="text-white text-sm md:text-base font-medium" data-id="element-52">
                    {row.con}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}